<template>
  <div :ref="id">
    <right-panel :class="classes" :id="id" :width="panelWidth" :icon="'mdi mdi-plus'" :text="text" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <h5 style="margin-top: 0.5em;">
            {{ title }}
          </h5>
          <slot></slot>
        </div>

        <div v-if="pagination && pagination.docs">
          <input class="form-control mt-3 mb-3" v-model="nameFilter" :placeholder="$t('common.search')" />
          <!-- <b-card
            v-for="option in pagination.docs"
            :key="option._id"
            @click="select(option)"
            header-class="bg-transparent border-primary"
            class="border border-primary m-1 mr-4"
            style="cursor: pointer"
            :class="{
              'bg-primary': isSelected(option),
              'text-white': isSelected(option),
            }"
          >
            {{ option.name | translate }}
          </b-card> -->

          <b-card
            v-for="item in pagination.docs"
            no-body
            class="shadow-none mb-1"
            :key="item._id"
            :class="{
              'bg-primary text-white': isSelected(item),
            }"
          >
            <b-card-body class="p-2 hider">
              <i v-if="isSelected(item)" class="bx bx-trash float-right text-white hand" v-b-tooltip.hover :title="$t('common.un-select')" @click="select(item)"></i>
              <i v-else class="mdi mdi-plus float-right text-success hand" v-b-tooltip.hover :title="$t('common.select')" @click="select(item)"></i>
              <h6
                class="mb-0"
                :class="{
                  'text-white': isSelected(item),
                }"
              >
                <template v-if="item.scope">
                  <i v-if="item.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class=" mdi mdi-hexagon-multiple-outline"></i>
                  <i v-else class=" mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                </template>
                {{ item.name | translate }}
              </h6>
            </b-card-body>
          </b-card>

          <content-loading v-if="isLoading" />
          <!-- Begin: Pagination -->

          <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
            <h5 class="text-center" id="myText">
              {{ $t("data.no-data") }}
            </h5>
          </empty>

          <div v-if="pagination" class="row">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
              </ul>
            </div>
          </div>
          <!-- End: Pagination -->
        </div>

        <!---->
        <sweet-button v-if="multiple" @click="ok()" variant="success" icon="bx bx-check" size="sm" buttonClass="mt-3">
          {{ $t("common.ok") }}
        </sweet-button>
      </div>
    </right-panel>
  </div>
</template>

<script>
export default {
  props: ["id", "text", "title", "store", "multiple", "selected", "classes", "width"],
  data() {
    return {
      nameFilter: undefined,
      selections: [],
      request: {
        options: { limit: 15 },
        query: {},
      },
    };
  },
  computed: {
    panelWidth() {
      return this.width || "600px";
    },
    pagination() {
      return this.$store.getters[`${this.store}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${this.store}/isLoading`];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.reload(), this.id, 100);
      },
    },
    selected: {
      deep: true,
      immediate: true,
      handler(values) {
        this.selections = Array.isArray(values) ? [...values] : values ? [values] : [];
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },
  methods: {
    reload() {
      this.$store.dispatch(`${this.store}/paginate`, this.request);
    },
    select(option) {
      if (!this.multiple) {
        this.closePanel();
        this.$emit("onSelected", option);
        return;
      }

      const founded = this.selections.find((i) => i._id == option._id);
      if (founded) {
        this.selections = [...this.selections.filter((i) => i._id != option._id)];
      } else {
        this.selections.push(option);
      }
    },

    isSelected(option) {
      return !!this.selections.find((i) => i._id == option._id);
    },
    ok() {
      this.closePanel();
      this.$emit("onSelected", this.selections);
    },
    closePanel() {
      this.$root.$emit("bv::toggle::collapse", this.id);
    },
    rightPanelClosed() {},
  },
};
</script>

<style></style>
